import { render, staticRenderFns } from "./miodata-analyze.vue?vue&type=template&id=889047cc&scoped=true&"
import script from "./miodata-analyze.vue?vue&type=script&lang=ts&"
export * from "./miodata-analyze.vue?vue&type=script&lang=ts&"
import style0 from "./miodata-analyze.vue?vue&type=style&index=0&id=889047cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "889047cc",
  null
  
)

export default component.exports